// useQueryDetails Hook
import { useState, useEffect, useCallback, useMemo } from "react";
import { QueryEntity } from "../../domain/entities/QueryEntity";
import { GetQueryDetailsUseCase } from "../../domain/use-cases/GetQueryDetailsUseCase";
import { QueriesRepositoryImpl } from "../../data/repositories/QueriesRepositoryImpl";
import { queriesApi } from "../../data/api/queriesApi";

export const useQueryDetails = (queryId: number | undefined) => {
  const [query, setQuery] = useState<QueryEntity | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Instantiate repository and use case
  const repository = useMemo(() => new QueriesRepositoryImpl(queriesApi), []);

  const getDetailsUseCase = useMemo(
    () => new GetQueryDetailsUseCase(repository),
    [repository]
  );

  const fetchDetails = useCallback(async () => {
    if (!queryId) {
      setQuery(null);
      return;
    }

    setLoading(true);
    setError(null);

    const result = await getDetailsUseCase.execute(queryId);

    if (result.isSuccess) {
      setQuery(result.value);
      setError(null);
    } else {
      setQuery(null);
      setError(result.error);
    }

    setLoading(false);
  }, [queryId, getDetailsUseCase]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  return {
    query,
    loading,
    error,
    refetch: fetchDetails,
  };
};
